var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"switch",class:_vm.wrapClasses,on:{"click":_vm._toggle}},[_vm._ssrNode("<span"+(_vm._ssrClass(null,_vm.innerClasses))+">","</span>",[(_vm.currentValue)?_vm._t("open"):_vm._e(),_vm._ssrNode(" "),(!_vm.currentValue)?_vm._t("close"):_vm._e()],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3524cae","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/switch/switch.vue
// module id = 593
// module chunks = 0 1 47